import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import Tooltip from '../ToolTip.jsx';

const Label = ({
    controlId,
    label,
    labelComponent,
    tooltip,
    buttonTooltip = false,
    isRequired
}) => {
    const [translate] = useTranslation();

    const requiredIndicator = useMemo(() => {
        if (isRequired) {
            return <span className='text-danger'> *</span>;
        }

        return null;
    }, [isRequired]);

    const buttonTooltipElement = useMemo(() => {
        if (buttonTooltip && tooltip) {
            return <Tooltip text={tooltip} />;
        }

        return null;
    }, [buttonTooltip, tooltip]);

    const nonButtonTooltipElement = useMemo(() => {
        if (!buttonTooltip && tooltip) {
            return <div className="text-secondary" style={{ fontSize: '0.7em' }}>{tooltip}</div>;
        }

        return null;
    }, [buttonTooltip, tooltip]);

    if (labelComponent || label) {
        return (
            <>
                <div className="d-flex align-items-center mb-1">
                    <label htmlFor={controlId} className='d-block form-label h6 lh-sm mb-0'>{labelComponent || translate(label)}{requiredIndicator}</label>
                    {buttonTooltipElement}
                </div>
                {nonButtonTooltipElement}
            </>
        );
    }

    return null;
};

export default Label;